import React, { useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTheme, useMediaQuery, CircularProgress } from "@mui/material";

import * as S from "./Styled";
import useCouponData from "../../../../hooks/useCouponData";
import { NewCoupons } from "../CarouselCoupons/NewCoupons";
import { categoriasClubeDoAluno } from "../../../../constants/HomeCupom/categoryIcon";

export default function NewCouponsCarousel({logo,modalTitle,category,order,slug,name,page, type, limit, userId, incentiveId, getcouponRedirect, utmSource, utmCampaign, showAlert, openCoupon,isAuthenticated}) {
    
    const { coupons, loadingCoupon, errorCoupon, totalPages } = useCouponData({
        slug,
        category,
        name,
        type,
        limit,
        order
    });
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    const isLargeDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    const itemsPerPage = isMobile ? 3 : isLargeDesktop ? 5 : isTablet ? 3 : 4;
    const itemWidth = isMobile ? 134 : isLargeDesktop ? 190 : 200;
    const gap = isMobile ? 16 : isLargeDesktop ? 20 : 31.5;
    const containerWidth = itemsPerPage * itemWidth + (itemsPerPage - 1) * gap;

    const [currentIndex, setCurrentIndex] = useState(0);
    const totalItems = coupons && coupons.data ? coupons.data.length : 0;
    const maxIndex = Math.max(totalItems - itemsPerPage, 0);
    // Evita deslocamento ao aumentar a janela depois de avançar o carrossel
    const safeIndex = Math.min(currentIndex, maxIndex);

    const handlePrev = () => setCurrentIndex(Math.max(safeIndex - 1, 0));
    const handleNext = () => setCurrentIndex(Math.min(safeIndex + 1, maxIndex));

    if (!coupons || !coupons.data || coupons.data.length === 0) {
        return null;
    }

    return (
        <div id="acabou-de-chegar">
            <S.Container width={containerWidth}>
            <S.Title variant="h4" sx={{ fontFamily: "'Noto Sans', sans-serif" }}>
                Acabou de chegar
            </S.Title>
             {isMobile ? (
                /* ===== MOBILE (scroll) ===== */
                <S.CarouselAreaMobile>
                    <S.CarouselContentMobile>
                    <NewCoupons
                        coupons={coupons}
                        getcouponRedirect={getcouponRedirect}
                        utmSource={utmSource}
                        utmCampaign={utmCampaign}
                        userId={userId}
                        incentiveId={incentiveId}
                        showAlert={showAlert}
                        openCoupon={openCoupon}
                        itemWidth={itemWidth}
                        isAuthenticated={isAuthenticated}
                        isMobile={isMobile}
                        modalTitle={modalTitle}
                        slug={slug}
                        logo={logo}
                    />
                    </S.CarouselContentMobile>
                </S.CarouselAreaMobile>
            ) : (
                /* ===== DESKTOP / TABLET (setas) ===== */
                <S.RelativeContainer>
                    {safeIndex > 0 && (
                    <S.ArrowButtonLeft onClick={handlePrev}>
                        <ArrowBackIosNewIcon />
                    </S.ArrowButtonLeft>
                    )}

                    <S.CarouselArea width={containerWidth}>
                    <S.CarouselContent
                        gap={gap}
                        translate={safeIndex * (itemWidth + gap)}
                    >
                        <NewCoupons
                        coupons={coupons}
                        getcouponRedirect={getcouponRedirect}
                        utmSource={utmSource}
                        utmCampaign={utmCampaign}
                        userId={userId}
                        incentiveId={incentiveId}
                        showAlert={showAlert}
                        openCoupon={openCoupon}
                        itemWidth={itemWidth}
                        isAuthenticated={isAuthenticated}
                        isMobile={isMobile}
                        modalTitle={modalTitle}
                        slug={slug}
                        logo={logo}
                        />
                    </S.CarouselContent>
                    </S.CarouselArea>

                    {safeIndex < maxIndex && (
                    <S.ArrowButtonRight onClick={handleNext}>
                        <ArrowForwardIosIcon />
                    </S.ArrowButtonRight>
                    )}
                </S.RelativeContainer>
            )}

            </S.Container>
        </div>
    );
}
